export default __webpack_public_path__ + "static/media/receive token.59f8f3e3.png";